export const downloadFormDatCLINICAL = ` <div className="mb-4">
  <h4>
    <b>Legal Disclaimer for Clinical Safety Officer Handbook and Compliance Toolkit</b>
  </h4>
  <p>
  The Clinical Safety Officer Handbook and Compliance Toolkit (hereafter referred to as "the Handbook") is offered by IG-Smart Ltd (hereafter referred to as "the Consultancy") through our website. This legal disclaimer outlines the terms and conditions that govern your use of the Handbook. By accessing and using the Handbook, you accept and agree to comply with the following terms:
  </p>
  <div className="custom-list">
    <ul>
      <li className="py-1 mb-1">
         <b>No Legal or Professional Advice</b> <br />
         <p>The Handbook is intended for informational purposes only and does not constitute legal, medical, or professional advice. It is not a substitute for legal or professional consultation. The Consultancy does not guarantee the accuracy, completeness, or currency of the information provided. Consult with qualified professionals for advice tailored to your specific situation.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Limited Liability</b>
       <p>The Consultancy, its officers, employees, and affiliates, are not liable for any damages or losses arising from your use of the Handbook. This includes, but is not limited to, direct, indirect, incidental, punitive, and consequential damages.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Copyright and Intellectual Property:</b>
       <p>The Handbook and its content are protected by copyright and intellectual property laws. All rights not expressly granted in this disclaimer are reserved by the Consultancy. You may use the Handbook for personal, non-commercial purposes. Any unauthorized reproduction, distribution, or modification of the Handbook's content is prohibited.</p>
      </li>
      <li className="py-1 mb-1">
       <b>No Endorsement:</b>
       <p>Mention of any specific product, service, or organization within the Handbook does not constitute an endorsement or recommendation by the Consultancy. The inclusion of such content is for informational purposes only.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Website Links:</b>
       <p>The Handbook may contain links to external websites that are not under the control of the Consultancy. The Consultancy is not responsible for the content, security, or privacy practices of these external websites. Access them at your own risk.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Changes and Updates:</b>
       <p>The Consultancy reserves the right to change, modify, or update the content of the Handbook at any time without notice. Your continued use of the Handbook implies your acceptance of any changes made.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Governing Law:</b>
       <p>This legal disclaimer is governed by the laws of the jurisdiction in which the Consultancy is registered and operates.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Contact Information:</b>
       <p>For questions or concerns related to the Handbook or this legal disclaimer, please contact:<a href="mailto:info@ig-smart.com">info@ig-smart.com</a> </p>
      </li>
    </ul>
  </div>
</div>  `


export const downloadFormDatISO = ` <div className="mb-4">
  <h4>
    <b>printing and typesetting industry. the industry's standard dummy text ever since th</b>
  </h4>
  <p>
  The Clinical Safety Officer Handbook and Compliance Toolkit (hereafter referred to as "the Handbook") is offered by IG-Smart Ltd (hereafter referred to as "the Consultancy") through our website. This legal disclaimer outlines the terms and conditions that govern your use of the Handbook. By accessing and using the Handbook, you accept and agree to comply with the following terms:
  </p>
  <div className="custom-list">
    <ul>
      <li className="py-1 mb-1">
         <b>No Legal or Professional Advice</b> <br />
         <p>The Handbook is intended for informational purposes only and does not constitute legal, medical, or professional advice. It is not a substitute for legal or professional consultation. The Consultancy does not guarantee the accuracy, completeness, or currency of the information provided. Consult with qualified professionals for advice tailored to your specific situation.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Limited Liability</b>
       <p>The Consultancy, its officers, employees, and affiliates, are not liable for any damages or losses arising from your use of the Handbook. This includes, but is not limited to, direct, indirect, incidental, punitive, and consequential damages.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Copyright and Intellectual Property:</b>
       <p>The Handbook and its content are protected by copyright and intellectual property laws. All rights not expressly granted in this disclaimer are reserved by the Consultancy. You may use the Handbook for personal, non-commercial purposes. Any unauthorized reproduction, distribution, or modification of the Handbook's content is prohibited.</p>
      </li>
      <li className="py-1 mb-1">
       <b>No Endorsement:</b>
       <p>Mention of any specific product, service, or organization within the Handbook does not constitute an endorsement or recommendation by the Consultancy. The inclusion of such content is for informational purposes only.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Website Links:</b>
       <p>The Handbook may contain links to external websites that are not under the control of the Consultancy. The Consultancy is not responsible for the content, security, or privacy practices of these external websites. Access them at your own risk.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Changes and Updates:</b>
       <p>The Consultancy reserves the right to change, modify, or update the content of the Handbook at any time without notice. Your continued use of the Handbook implies your acceptance of any changes made.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Governing Law:</b>
       <p>This legal disclaimer is governed by the laws of the jurisdiction in which the Consultancy is registered and operates.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Contact Information:</b>
       <p>For questions or concerns related to the Handbook or this legal disclaimer, please contact:<a href="mailto:info@ig-smart.com">info@ig-smart.com</a> </p>
      </li>
    </ul>
  </div>
</div>  `


export const downloadFormDatNHS = ` <div className="mb-4">
  <h4>
    <b>the printing and typesetting industry standard dummy text ever since th</b>
  </h4>
  <p>
  The Clinical Safety Officer Handbook and Compliance Toolkit (hereafter referred to as "the Handbook") is offered by IG-Smart Ltd (hereafter referred to as "the Consultancy") through our website. This legal disclaimer outlines the terms and conditions that govern your use of the Handbook. By accessing and using the Handbook, you accept and agree to comply with the following terms:
  </p>
  <div className="custom-list">
    <ul>
      <li className="py-1 mb-1">
         <b>No Legal or Professional Advice</b> <br />
         <p>The Handbook is intended for informational purposes only and does not constitute legal, medical, or professional advice. It is not a substitute for legal or professional consultation. The Consultancy does not guarantee the accuracy, completeness, or currency of the information provided. Consult with qualified professionals for advice tailored to your specific situation.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Limited Liability</b>
       <p>The Consultancy, its officers, employees, and affiliates, are not liable for any damages or losses arising from your use of the Handbook. This includes, but is not limited to, direct, indirect, incidental, punitive, and consequential damages.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Copyright and Intellectual Property:</b>
       <p>The Handbook and its content are protected by copyright and intellectual property laws. All rights not expressly granted in this disclaimer are reserved by the Consultancy. You may use the Handbook for personal, non-commercial purposes. Any unauthorized reproduction, distribution, or modification of the Handbook's content is prohibited.</p>
      </li>
      <li className="py-1 mb-1">
       <b>No Endorsement:</b>
       <p>Mention of any specific product, service, or organization within the Handbook does not constitute an endorsement or recommendation by the Consultancy. The inclusion of such content is for informational purposes only.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Website Links:</b>
       <p>The Handbook may contain links to external websites that are not under the control of the Consultancy. The Consultancy is not responsible for the content, security, or privacy practices of these external websites. Access them at your own risk.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Changes and Updates:</b>
       <p>The Consultancy reserves the right to change, modify, or update the content of the Handbook at any time without notice. Your continued use of the Handbook implies your acceptance of any changes made.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Governing Law:</b>
       <p>This legal disclaimer is governed by the laws of the jurisdiction in which the Consultancy is registered and operates.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Contact Information:</b>
       <p>For questions or concerns related to the Handbook or this legal disclaimer, please contact:<a href="mailto:info@ig-smart.com">info@ig-smart.com</a> </p>
      </li>
    </ul>
  </div>
</div>  `


export const downloadFormDatGDPR = ` <div className="mb-4">
  <h4>
    <b>the printing and typesetting industry's standard dummy text ever since th</b>
  </h4>
  <p>
  The Clinical Safety Officer Handbook and Compliance Toolkit (hereafter referred to as "the Handbook") is offered by IG-Smart Ltd (hereafter referred to as "the Consultancy") through our website. This legal disclaimer outlines the terms and conditions that govern your use of the Handbook. By accessing and using the Handbook, you accept and agree to comply with the following terms:
  </p>
  <div className="custom-list">
    <ul>
      <li className="py-1 mb-1">
         <b>No Legal or Professional Advice</b> <br />
         <p>The Handbook is intended for informational purposes only and does not constitute legal, medical, or professional advice. It is not a substitute for legal or professional consultation. The Consultancy does not guarantee the accuracy, completeness, or currency of the information provided. Consult with qualified professionals for advice tailored to your specific situation.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Limited Liability</b>
       <p>The Consultancy, its officers, employees, and affiliates, are not liable for any damages or losses arising from your use of the Handbook. This includes, but is not limited to, direct, indirect, incidental, punitive, and consequential damages.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Copyright and Intellectual Property:</b>
       <p>The Handbook and its content are protected by copyright and intellectual property laws. All rights not expressly granted in this disclaimer are reserved by the Consultancy. You may use the Handbook for personal, non-commercial purposes. Any unauthorized reproduction, distribution, or modification of the Handbook's content is prohibited.</p>
      </li>
      <li className="py-1 mb-1">
       <b>No Endorsement:</b>
       <p>Mention of any specific product, service, or organization within the Handbook does not constitute an endorsement or recommendation by the Consultancy. The inclusion of such content is for informational purposes only.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Website Links:</b>
       <p>The Handbook may contain links to external websites that are not under the control of the Consultancy. The Consultancy is not responsible for the content, security, or privacy practices of these external websites. Access them at your own risk.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Changes and Updates:</b>
       <p>The Consultancy reserves the right to change, modify, or update the content of the Handbook at any time without notice. Your continued use of the Handbook implies your acceptance of any changes made.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Governing Law:</b>
       <p>This legal disclaimer is governed by the laws of the jurisdiction in which the Consultancy is registered and operates.</p>
      </li>
      <li className="py-1 mb-1">
       <b>Contact Information:</b>
       <p>For questions or concerns related to the Handbook or this legal disclaimer, please contact:<a href="mailto:info@ig-smart.com">info@ig-smart.com</a> </p>
      </li>
    </ul>
  </div>
</div>  `




